<template>
	<main class="list">
		<header class="content ">
			<div class="card-header bg-1">
				<router-link
					:to="{ path: '/users/edit'}"
					tag="button"
					class="btn btn-primary pull-right">New User</router-link>

				<router-link
					:to="{ path: '/users/levels'}"
					tag="button"
					class="btn btn-primary pull-right mr-3">Levels</router-link>

				<h4 class="mb-0 mt-1 ml-5">Users</h4>
				<p class="lead text-muted">List of all users</p>
			</div>
		</header>
		<div class="content">
			<table class="table table-hover table-clean table">
					<thead>
						<tr>
							<th>Name</th>
							<th>Email</th>
							<th>Level</th>
							<th>Created</th>
							<th>Updated</th>
						</tr>
					</thead>
					<tbody>
						<router-link
							:to="{ path: `/users/edit/${user.id}`}"
							v-for="user in user_list"
							v-bind:key="user.id"
							tag="tr">
							<td>{{user.name}}</td>
							<td>{{user.email}}</td>
							<td>{{user.level ? user.level.name : 'Unset'}}</td>
							<td>{{$moment(user.created_at).calendar(null,{sameElse: 'lll'})}}</td>
							<td>{{$moment(user.updated_at).calendar(null,{sameElse: 'lll'})}}</td>
						</router-link>
					</tbody>
				</table>
		</div>
	</main>
</template>

<script>
export default {
	name: 'UsersList',
	props: {
		users: Object,
	},
	data: function() {
		return {user_list: this.users};
	},
	mounted: function() {
		const p = this.$Progress;
		const a = this.$axios;
		const that = this;

		this.$nextTick(function() {
			p.start();

			a.get('/user')
				.then((response) => {
					that.user_list = response.data;
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(()=>{
					p.finish();
				});
		});
	},
};
</script>

<style scoped>
	tr{ cursor: pointer; }
</style>
